import moment from 'moment';
import React from 'react';
import { getSelectedCommunication } from 'selectors/communications';
import { GroupedRenderedActions } from 'selectors/envelopes';
import { useSelector } from 'store';
import EnvelopeSessionCommentItem from './EnvelopeSessionCommentItem';

type ComponentProps = {
  session: GroupedRenderedActions;
  shouldRenderDate: boolean;
  index: number;
  includeSentMessage: boolean;
};

const EnvelopeSessionItem: React.FC<ComponentProps> = (props) => {
  const { session, shouldRenderDate, index, includeSentMessage = false } = props;

  const communication = useSelector(getSelectedCommunication);

  return (
    <div
      className={`relative flex flex-col gap-1 ${index === 0 || shouldRenderDate ? 'mt-8' : ''}`}
    >
      <div className="flex flex-row gap-1 text-body">
        <p className="">{session.user.name}</p>
        <p className="text-litlingo-gray-4">
          {moment(session.actions[0].created_at).format('hh:mm a')}
        </p>
      </div>
      <ul className="text-small list-disc list-outside">
        {session.actions
          .sort((a, b) => {
            if (a.type === 'comment') return 1;
            if (b.type === 'comment') return -1;
            return -1;
          })
          .map((action) =>
            action.type === 'comment' ? (
              <EnvelopeSessionCommentItem key={action.uuid} action={action} />
            ) : (
              <li key={action.uuid} className="ml-6">
                {action.description}
              </li>
            )
          )}
      </ul>

      <div className="absolute w-3 h-3 text-litlingo-gray-2" style={{ top: 5, left: -20 }}>
        <svg viewBox="0 0 12 12" fill="currentColor">
          <circle cx={5} cy={5} r={5} />
        </svg>
      </div>

      {(index === 0 || shouldRenderDate) && (
        <div
          className="absolute text-small transform -translate-x-1/2"
          style={{ top: -32, left: -14 }}
        >
          <div className="px-1 w-15 flex justify-center border-2 border-litlingo-gray-2 rounded font-bold bg-white">
            {moment(session.actions[0].created_at).format('MMM DD')}
          </div>
        </div>
      )}

      {includeSentMessage && communication && (
        <div className="relative mt-8">
          <span className="text-body">{`Message sent at ${moment(communication.sent_at).format(
            'hh:mm a'
          )}`}</span>
          <div
            className="absolute text-small transform -translate-x-1/2"
            style={{ top: -26, left: -14 }}
          >
            <div className="px-1 w-15 flex justify-center border-2 border-litlingo-gray-2 rounded font-bold bg-white">
              {moment(communication.sent_at).format('MMM DD')}
            </div>
          </div>
          <div className="absolute w-3 h-3 text-litlingo-gray-2" style={{ top: 7, left: -20 }}>
            <svg viewBox="0 0 12 12" fill="currentColor">
              <circle cx={5} cy={5} r={5} />
            </svg>
          </div>
          <div className="absolute w-3 h-3" style={{ bottom: -5, left: -16 }}>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <line x1="1" y1="0" x2="1" y2="8" stroke="white" strokeWidth={2} />
            </svg>
          </div>
        </div>
      )}
    </div>
  );
};

export default EnvelopeSessionItem;
